import { Application } from '../config'
import { IPaymentGateway, IPaymentInit, IPendingRedsysPayment } from '../models'
import { StorageService } from '../services'

export const isRedsysPayment = (paymentInit?: IPaymentInit | null): paymentInit is IPaymentInit =>
  paymentInit?.gateway === IPaymentGateway.REDSYS

export const isIframeRedsysPayment = (gateway?: IPaymentGateway): boolean =>
  Application.isIframe && gateway === IPaymentGateway.REDSYS

export const redirectToRedsys = (paymentInit: IPaymentInit, pendingPayment: IPendingRedsysPayment): void => {
  if (!paymentInit.redsysUrl) throw new Error('Redsys payment without URL')

  StorageService.setPendingRedsysPayment(pendingPayment)

  const form = document.createElement('form')
  form.method = 'POST'
  form.action = paymentInit.redsysUrl
  form.style.display = 'none'

  const fields: [string, string | null][] = [
    ['Ds_SignatureVersion', paymentInit.redsysSignatureVersion],
    ['Ds_MerchantParameters', paymentInit.redsysMerchantParameters],
    ['Ds_Signature', paymentInit.redsysSignature]
  ]
  fields.forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value ?? ''
    form.appendChild(input)
  })

  document.body.appendChild(form)
  form.submit()
}
